<dx-box width="100%" height="100%" direction="col" class="side-menu-container cc-side-navigator-menu">
    <dxi-item baseSize="auto" [visible]="!compactMode">
        <div *dxTemplate>
            <app-side-navigation-search-toolbar
                [visible]="!compactMode"
                [menuItems]="topItems"
                [selectedNode]="selectedNode"
                (onNavigationChange)="onNavigationChange($event)"
            ></app-side-navigation-search-toolbar>
        </div>
    </dxi-item>
    <dxi-item
        [ratio]="1"
        class="tree-content-view"
        [ngClass]="{
            'tree-view-expanded': !compactMode,
            'tree-view-collapsed': compactMode
        }"
    >
        <!-- Scroll view required for MAC to display devextreme scroll bar.  -->
        <dx-scroll-view
            #topScrollView
            width="100%"
            height="100%"
            direction="both"
            [scrollByContent]="true"
            [useNative]="false"
            [showScrollbar]="showScrollbar"
        >
            <dx-tree-view
                #topTreeView
                width="100%"
                height="100%"
                keyExpr="id"
                expandEvent="click"
                selectionMode="single"
                itemTemplate="topItemTemplate"
                [dataSource]="topItems"
                [selectByClick]="false"
                [focusStateEnabled]="false"
                [activeStateEnabled]="false"
                (onItemClick)="onTreeItemClick($event)"
                (onItemExpanded)="onTreeItemExpanded()"
            >
                <div *dxTemplate="let navItem of 'topItemTemplate'" (click)="onTopItemClick(navItem)">
                    <ng-container
                        [ngTemplateOutlet]="treeItemTemplate"
                        [ngTemplateOutletContext]="{ navItem: navItem }"
                    ></ng-container>
                </div>
            </dx-tree-view>
        </dx-scroll-view>
        <!-- selected menu name in compact mode -->
        <div *ngIf="selectedNode && compactMode && hasHeight" class="selected-menu-item">
            <div class="selected-menu-label">{{ selectedNode?.text }}</div>
        </div>
    </dxi-item>
    <!-- bottom menu -->
    <dxi-item baseSize="auto" [visible]="!compactMode">
        <dx-toolbar class="footer-toolbar cc-search-toolbar-container">
            <dxi-item location="before">
                <div *dxTemplate class="toolbar-item-container">
                    <div class="toolbar-button-container">
                        <div class="button-container" *ngFor="let button of bottomItems.slice(0, 4)">
                            <dx-button
                                [ngClass]="{
                                    'search-button': !button.selected,
                                    'selected-search-button': button.selected,
                                    'cc-qa-release-menu': isInQaRelease(button),
                                    'cc-dev-release-menu': isInDevRelease(button)
                                }"
                                type="normal"
                                [stylingMode]="'text'"
                                [icon]="button.icon"
                                [hint]="button.tooltip"
                                [visible]="button.hasAccess"
                                (onClick)="onBottomItemClick(button)"
                            >
                                <div *dxTemplate="let c of 'content'">
                                    <i
                                        *ngIf="c.icon.indexOf('span') === -1"
                                        class="dx-icon"
                                        aria-hidden="true"
                                        [ngClass]="c.icon"
                                    ></i>
                                    <div *ngIf="c.icon.indexOf('span') !== -1" [innerHTML]="c.icon | ccSafeHtml"></div>
                                </div>
                            </dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate class="toolbar-item-container">
                    <div class="toolbar-button-container">
                        <div class="button-container" *ngFor="let button of bottomItems.slice(4)">
                            <dx-button
                                [ngClass]="{
                                    'search-button': !button.selected,
                                    'selected-search-button': button.selected,
                                    'cc-qa-release-menu': isInQaRelease(button),
                                    'cc-dev-release-menu': isInDevRelease(button)
                                }"
                                type="normal"
                                [stylingMode]="'text'"
                                [icon]="button.icon"
                                [hint]="button.tooltip"
                                [visible]="button.hasAccess"
                                (onClick)="onBottomItemClick(button)"
                            >
                                <div *dxTemplate="let c of 'content'">
                                    <i
                                        *ngIf="c.icon.indexOf('span') === -1"
                                        class="dx-icon"
                                        aria-hidden="true"
                                        [ngClass]="c.icon"
                                    ></i>
                                    <div *ngIf="c.icon.indexOf('span') !== -1" [innerHTML]="c.icon | ccSafeHtml"></div>
                                </div>
                            </dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
        </dx-toolbar>
    </dxi-item>
    <!-- footer toolbar-->
    <dxi-item baseSize="auto" class="top-border-box-item dx-theme-border-color">
        <dx-toolbar class="footer-toolbar">
            <dxi-item location="before">
                <div *dxTemplate>
                    <img [src]="ccLogo" alt="CiraConnect" height="30px" />
                </div>
            </dxi-item>
            <dxi-item location="before">
                <div *dxTemplate>
                    <img [src]="poweredByCCLogo" [ngStyle]="getCCPoweredByStyle()" alt="CiraConnect" height="30px" />
                </div>
            </dxi-item>
        </dx-toolbar>
        <div class="cc-version-text" [ngClass]="{ 'cc-version-center-text': compactMode }">
            <small class="dx-theme-accent-as-text-color">{{ appVersion }}</small>
        </div>
        <div class="cc-version-text" *ngIf="!compactMode">
            <small class="dx-theme-accent-as-text-color">&copy; 2004 - {{ currentYear }} CiraConnect, LLC.</small>
        </div>
        <div class="cc-version-text" *ngIf="!compactMode">
            <small class="dx-theme-accent-as-text-color">All rights reserved.</small>
        </div>
    </dxi-item>
</dx-box>

<ng-template #treeItemTemplate let-navItem="navItem">
    <div class="tree-item-template" [title]="navItem.tooltip">
        <ng-container *ngIf="navItem.icon.indexOf('span') === -1">
            <i
                *ngIf="!navItem.parentId || (navItem.parentId && !compactMode)"
                aria-hidden="true"
                [ngClass]="{
                    'selected-header-icon-button': navItem.selected,
                    'header-icon-button': !navItem.selected,
                    'cc-qa-release-menu': isInQaRelease(navItem),
                    'cc-dev-release-menu': !isInQaRelease(navItem)
                }"
                [class]="navItem.icon"
            ></i>
        </ng-container>
        <ng-container *ngIf="navItem.icon.indexOf('span') !== -1">
            <div
                *ngIf="!navItem.parentId || (navItem.parentId && !compactMode)"
                [ngClass]="{
                    'selected-header-icon-button': navItem.selected,
                    'header-icon-button': !navItem.selected,
                    'cc-qa-release-menu': isInQaRelease(navItem),
                    'cc-dev-release-menu': !isInQaRelease(navItem)
                }"
                [innerHTML]="navItem.icon | ccSafeHtml"
            ></div>
        </ng-container>
        <div
            *ngIf="!compactMode"
            [ngClass]="{
                'selected-header-text': navItem.selected,
                'header-text': !navItem.selected,
                'workspace-leaf-text': isWorkspaceLeaf(navItem)
            }"
        >
            <span
                *ngIf="isInDevOrQaRelease(navItem)"
                [ngClass]="{
                    'cc-qa-release-menu': isInQaRelease(navItem),
                    'cc-dev-release-menu': !isInQaRelease(navItem)
                }"
            >
                **&nbsp;{{ navItem.text }}&nbsp;**
            </span>
            <span *ngIf="!isInDevOrQaRelease(navItem)">
                {{ navItem.text }}
            </span>
            <app-security-info
                *ngIf="navItem.isInternal && navItem.isSpecificRole"
                iconColor="cc-hyper-link"
                securityIndicator="KEY"
                [accessCode]="navItem.name"
            ></app-security-info>
            <app-security-info
                *ngIf="navItem.isInternal && !navItem.isSpecificRole"
                iconColor="cc-hyper-link"
                securityIndicator="LOCK"
                [accessCode]="navItem.name"
            ></app-security-info>
        </div>
        <i
            *ngIf="hasExpandedItems(navItem) && !compactMode"
            class="fas fa-chevron-left"
            [ngClass]="{
                'selected-header-icon-button-back': navItem.selected,
                'header-icon-button-back': !navItem.selected
            }"
        ></i>
        <i
            *ngIf="hasCollapsedItems(navItem) && !compactMode"
            class="fas fa-chevron-right"
            [ngClass]="{
                'selected-header-icon-button-right': navItem.selected,
                'header-icon-button-right': !navItem.selected
            }"
        ></i>
    </div>
</ng-template>
